import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import he from './locales/he.json';

// i18next configuration
// גרסה 1.0: עברית בלבד, מוכן להרחבה עתידית
// להוספת שפה: צור קובץ locales/{lng}.json והוסף ל-resources
i18n.use(initReactI18next).init({
  resources: {
    he: { translation: he },
  },
  lng: 'he', // שפת ברירת מחדל — עברית
  fallbackLng: 'he',
  interpolation: {
    escapeValue: false, // React כבר מטפל ב-XSS
  },
  react: {
    useSuspense: false, // מונע flicker בטעינה ראשונית
  },
});

export default i18n;
